"use strict";

class CommonFooterController {
    constructor() {
        const self = this;
    }
}

CommonFooterController.$inject = [];
app.controller('CommonFooterController', CommonFooterController);
